import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import ComponentLog from '@/components/component-log';
import { env } from '@/env';
import goto from '@/common/goto';
import BaseProcess from '@/pages/operate-platform/components/report-process/components/base-process';

export default function Content(props) {
  const { id, name, auditProgress, endTime, finishedProgress, startTime, applyProgress } = props.data;
  const { dataSource } = props; // 数据来源，1:我参与的, 2:我创建的
  const jumpUrl = `/data-panel/flow-data/activityData/detail?id=${id}&userType=${dataSource}&activityStatus=1`;
  const [status, setStatus] = useState(false);

  // 进度条长度
  const getWidth = () => {
    const widthAuditOrFinished =
      dataSource === 2
        ? auditProgress.finished + '/' + auditProgress.total
        : finishedProgress.finished + '/' + finishedProgress.total;
    const widthApply = applyProgress.finished + '/' + applyProgress.total;
    const labelWidth = Math.max(widthAuditOrFinished.length, widthApply.length);
    return 85 - labelWidth * 3 + '%';
  };

  // 为了应对pd临时换边界值做的统一入口
  const outLength = 12;

  const Options = (total, finished) => {
    if (Number(total) === 0) {
      return {
        percent: 0,
        format: () => '0/0',
      };
    }
    if (total === finished) {
      return { percent: 100, status: 'success' };
    } else {
      const note = finished + '/' + total;
      return {
        // 如果有进度让进度最少是1%，对于1px以下的元素html2canvas生成图片会报错
        percent: finished === 0 ? 0 : Math.max(finished / total, 0.01) * 100,
        format: () => {
          if (note.length < outLength) {
            return <span>{note}</span>;
          } else {
            return (
              <Tooltip placement="top" title={note}>
                <div className="report-process-overflow" style={{ width: outLength * 8 }}>
                  {note}
                </div>
              </Tooltip>
            );
          }
        },
      };
    }
  };

  return (
    <div
      className="report-process-wrapper"
      onMouseEnter={() => {
        setStatus(true);
      }}
      onMouseLeave={() => setStatus(false)}
      style={{ width: props.width }}
    >
      <div>
        <div className="report-process-title" style={{ cursor: 'pointer' }}>
          <Tooltip placement="top" title={name}>
            {name}
          </Tooltip>
        </div>
        <div className="report-process-id-time report-process-id">活动ID: {id}</div>
        <div className="report-process-id-time report-process-time">
          活动时间: {startTime}-{endTime}
        </div>
        <div className="report-process-content-wrapper">
          <BaseProcess
            title={
              <>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                  <path
                    d="M0 2C0 0.895431 0.895431 0 2 0H8.78002C9.32023 0 9.83745 0.218522 10.214 0.605843L13.434 3.91782C13.7969 4.29114 14 4.7913 14 5.31197V14C14 15.1046 13.1046 16 12 16H2C0.89543 16 0 15.1046 0 14V2Z"
                    fill="#2676FE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.96815 5.19613L10.806 6.03333C11.0649 6.29471 11.0649 6.71745 10.806 6.97616L10.163 7.61866C10.0961 7.68267 9.99044 7.68267 9.92638 7.61866L8.38157 6.07507C8.31751 6.00826 8.31751 5.90264 8.38157 5.83863L9.02458 5.19613C9.28337 4.93462 9.70644 4.93462 9.96815 5.19613ZM3.19059 10.891L7.2521 6.82927C7.32097 6.76026 7.43476 6.76026 7.50953 6.83215L9.17056 8.49339C9.23944 8.56528 9.23944 8.67894 9.17056 8.74782L5.10906 12.8095L3.4001 12.9981C3.16964 13.022 2.97807 12.8275 3.00203 12.6L3.19059 10.891Z"
                    fill="white"
                  />
                </svg>
                &nbsp;报名进度
              </>
            }
            tipTitle={dataSource === 2 ? '报名数/分配数' : '他人报名数/分配数'}
            processWidth={getWidth()}
            strokeColor={{
              '0%': '#2676FE',
              '100%': '#2676FE',
            }}
            attrs={Options(applyProgress.total, applyProgress.finished)}
          />
          <BaseProcess
            title={
              <>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                  <path
                    d="M0 2C0 0.895431 0.895431 0 2 0H8.78002C9.32022 0 9.83745 0.218522 10.214 0.605843L13.434 3.91782C13.7969 4.29114 14 4.7913 14 5.31198V14C14 15.1046 13.1046 16 12 16H2C0.89543 16 0 15.1046 0 14V2Z"
                    fill="#FEB00E"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.46786 9.7H10.4088C10.7353 9.7 11 9.96798 11 10.2986V11.5H3.0001V10.2986C3.0001 9.96798 3.26477 9.7 3.59123 9.7H5.53205C5.70708 9.49079 5.83142 9.25376 5.85176 8.98789C5.89249 8.45672 5.63711 8.06078 5.36522 7.63922C5.08053 7.19783 4.77773 6.72836 4.77773 6.0462C4.77773 4.91347 5.62959 4 7 4C8.37031 4 9.22217 4.91347 9.22217 6.0462C9.22217 6.72828 8.91939 7.19772 8.63472 7.63909C8.36281 8.06067 8.10741 8.45665 8.14814 8.98789C8.16848 9.25366 8.29282 9.49079 8.46786 9.7ZM10.9999 12.1001H3V13.0001H10.9999V12.1001Z"
                    fill="white"
                  />
                </svg>{' '}
                &nbsp;{dataSource === 2 ? '审核进度' : '完成进度'}
              </>
            }
            tipTitle={dataSource === 2 ? '审核通过数/活动报名数' : '审核通过数/资源数'}
            processWidth={getWidth()}
            strokeColor={{
              '0%': '#FEB00E',
              '100%': '#FEB00E',
            }}
            attrs={
              dataSource === 2
                ? Options(auditProgress.total, auditProgress.finished)
                : Options(finishedProgress.total, finishedProgress.finished)
            }
          />
        </div>
        {status && (
          <ComponentLog>
            <div
              clstag="hd_gallery_1606447516680|18"
              className="report-process-detail"
              onClick={() => {
                window.log('yx_center', 'workbench_hcspjdclick', JSON.stringify({ activityid: id }));
                goto.toDataPanelRoomFlowDataDetail(id, dataSource).push();
              }}
            >
              <a>
                详情
                <RightOutlined />
              </a>
            </div>
          </ComponentLog>
        )}
      </div>
    </div>
  );
}
